import { CamelCaseNamingConvention, createMapper, PascalCaseNamingConvention } from '@automapper/core';
import { classes } from '@automapper/classes';

// Create and export the mapper
export const mapper = createMapper({
    strategyInitializer: classes(),
    // namingConventions: new CamelCaseNamingConvention(),


    // namingConventions: {
    //     source: new CamelCaseNamingConvention(),
    //     destination: new PascalCaseNamingConvention(),
    //     // source: new PascalCaseNamingConvention(),
    //     // destination: new CamelCaseNamingConvention(),
    // }
});